module.exports = __webpack_public_path__ + "img/index_type_bg1.a8db502a.jpg";